const InstrumentRunnerIndex = () =>
  import("@/pages/lab/instrumentrunner/InstrumentRunnerIndex");

const InstrumentRunnerSchedule = () => 
  import("@/pages/lab/instrumentrunner/InstrumentRunnerScheduleDetail")

export class InstrumentRunnerRoutes {
  constructor() {
    this.route_root = "instrument-runner";
    this.type_single = "Instrument Runner";
    this.type_plural = "Instrument Runners";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: this.route_root,
        name: this.type_single,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            component: InstrumentRunnerIndex,
            meta: { requiresAuth: true },
          },
          {
            path: ":scheduleId",
            name: `Schedule`,
            component: InstrumentRunnerSchedule,
            meta: { requiresAuth: true }
          }
        ],
      },
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    const this_obj = new this();

    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    const this_obj = new this();

    return this_obj.public_routes;
  }

}